import React, { FunctionComponent, useMemo } from "react";

import { IDataSourceAttribute } from "@multiweb/reactCore/datasource";
import { EMPTY_ARRAY } from "@multiweb/reactUtils";
import { TypedObject } from "@multiweb/types/react";
import { ActionArea, RowTemplateType } from "../../types";
import { DataRowTemplateProps } from "../DataRowTemplate";
import { TemplateLayout } from "../TemplateLayout";
import { getItems } from "./utils";

export type DataRowTemplateComponentProps = DataRowTemplateProps & {
    /** Obsahuje seřazené ikonové atributy k zobrazení. */
    iconDataSourceAttributeNames?: ReadonlyArray<string>;
    /** Obsahuje seřazené atributy s obsahem k zobrazení. */
    contentDataSourceAttributeNames?: ReadonlyArray<string>;
    /** Načtené DataSource atributy. */
    dataSourceAttributes?: TypedObject<IDataSourceAttribute>;
    /** Oblast, do které se mají akce vykreslit. */
    actionArea?: ActionArea;
    /** Určuje, jakým způsobem se bude zobrazovat obsah (SingleLine, Multiline, atd). */
    rowTemplate?: RowTemplateType;
};

/** Konstanta udávající, že ActionArea má využít 100% šířka řádku (pro menší část je nutné číslo zmenšit) */
const FULL_SIZE = 1;

/**
 * Komponenta vykreslující atributy podle template.
 */
export const DataRowTemplateComponent: FunctionComponent<DataRowTemplateComponentProps> = ({
    dataSourceKey,
    recordId,
    iconDataSourceAttributeNames = EMPTY_ARRAY as string[],
    contentDataSourceAttributeNames = EMPTY_ARRAY as string[],
    dataSourceAttributes,
    rowTemplate,
    actionArea,
}) => {
    const iconItems = useMemo(() => getItems(iconDataSourceAttributeNames, dataSourceKey, recordId, dataSourceAttributes),
        [dataSourceKey, recordId, iconDataSourceAttributeNames, dataSourceAttributes]);

    const contentItems = useMemo(() => getItems(contentDataSourceAttributeNames, dataSourceKey, recordId, dataSourceAttributes),
        [dataSourceKey, recordId, contentDataSourceAttributeNames, dataSourceAttributes]);

    return (
        // Pokud je actionArea dole chceme aby byla rozstáhlá přes celou šířku
        <TemplateLayout
            {...{ iconItems, contentItems, dataSourceKey, recordId, actionArea, rowTemplate }}
            actionAreaSize={ actionArea === ActionArea.aaBottom ? FULL_SIZE : undefined }
        />
    );
};
